import React, { useContext, useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router";
import { Space, Tag, Input } from "antd";
import {
  getExecutiveTagList,
  saveAdvancedSelectedFilters as executiveAdvancedSelectedFilters,
} from "../../actionCreator/executiveListingActionCreater";
import {
  getCompanyTagList,
  saveAdvancedSelectedFilters,
} from "../../actionCreator/companyListingActionCreater";
import { getUserInfo } from "../../utils/utils";
import { SearchOutlined } from "@ant-design/icons";
import { AuthContext } from "../../context/AuthContext";

const TagsReport = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { isExecutiveView, isCompanyView } = useContext(AuthContext);
  const [companyTagData, setCompanyTagData] = useState([]);
  const [executiveTagData, setExecutiveTagData] = useState([]);
  const userAccountInfo = useSelector(
    (state) => state.CommonReducer.accountInfo
  );
  const executiveCompanyTagList = useSelector(
    (state) => state.executiveListingReducer.companyTagList
  );
  const companyTagList = useSelector(
    (state) => state.companyListingReducer.companyTagList
  );
  const companySelectedFilterList = useSelector(
    (state) => state.companyListingReducer.selectedFilters
  );
  useEffect(() => {
    setCompanyTagData(companyTagList);
    setExecutiveTagData(executiveCompanyTagList);
  }, [companyTagList, executiveCompanyTagList]);

  useEffect(() => {
    if (Object.keys(getUserInfo()).length) {
      const { id } = getUserInfo();
      dispatch(getExecutiveTagList(id));
      dispatch(getCompanyTagList(id));
    }
  }, [userAccountInfo]);

  const filterKeyword = (ele) => {
    const filterdData = companyTagList?.filter((item) =>
      item?.toLowerCase().includes(ele?.target?.value?.toLowerCase())
    );
    setCompanyTagData(filterdData);
  };
  const filterExecutiveTag = (ele) => {
    const filterdData = executiveCompanyTagList?.filter((item) =>
      item?.toLowerCase().includes(ele?.target?.value?.toLowerCase())
    );
    setExecutiveTagData(filterdData);
  };

  const colorArray1 = [
    "#43ACFF",
    "#EF5261",
    "#FAC300",
    "#9AD888",
    "#18B0A7",
    "#3C78D8",
    "#43ACFF",
    "#EF5261",
    "#FAC300",
    "#9AD888",
  ];
  function repeatFor(arr, size) {
    var newArr = new Array(size);
    for (var i = 0; i < size; i++) {
      newArr[i] = arr[i % size];
    }
    return newArr;
  }
  const doSearchByTag = (item, type) => {
    if (type == 1) {
      //for comapny tags
      let payload = {
        selectedCountry: [],
        selectedState: [],
        selectedCity: [],
        selectedIndustry: [],
        selectedCompanytype: [],
        selectedEmployeecount: [],
        selectedRevenuerange: [],
        searchKeyword: "",
        selectedSavedSearch: [],
        selectedCompanyTag: [item],
      };
      dispatch(saveAdvancedSelectedFilters(payload));
      navigate("/search-company");
    } else {
      let payload = {
        selectedCountry: [],
        selectedState: [],
        selectedCity: [],
        selectedIndustry: [],
        selectedCompanytype: [],
        selectedEmployeecount: [],
        selectedRevenuerange: [],
        searchKeyword: "",
        selectedSavedSearch: [],
        selectedCompanyTag: [item],
        selectedExecutiveFunction: [],
        selectedExecutiveLevel: [],
      };
      dispatch(executiveAdvancedSelectedFilters(payload));
      navigate("/search-executive");
    }
  };
  const colorArray = repeatFor(colorArray1, colorArray1.length);
  return (
    <>
      <div className="row mx-0">
        {isCompanyView && (
          <div className="col-xl-6 col-lg-7">
            <div className="card shadow mb-4">
              <div className="card-header py-3 d-flex flex-row align-items-center justify-content-between">
                <h6 className="m-0 font-weight-bold text-gray-800 text-uppercase">
                  Company Tags
                </h6>
              </div>
              <div className="card-body" style={{ minHeight: "250px" }}>
                <div className="searchbox" style={{ marginBottom: "15px" }}>
                  <Input
                    placeholder="Search Tag"
                    prefix={<SearchOutlined />}
                    onChange={filterKeyword}
                  />
                </div>
                <div className="card-body">
                  <Space size={[0, companyTagData?.length]} wrap>
                    {companyTagData?.map((item, index) => {
                      return (
                        <Tag key={index} color={colorArray[index]}>
                          <a onClick={() => doSearchByTag(item, 1)}>{item}</a>
                        </Tag>
                      );
                    })}
                  </Space>
                </div>
              </div>
            </div>
          </div>
        )}
        {isExecutiveView && (
          <div className="col-xl-6 col-lg-7">
            <div className="card shadow mb-4">
              <div className="card-header py-3 d-flex flex-row align-items-center justify-content-between">
                <h6 className="m-0 font-weight-bold text-gray-800 text-uppercase">
                  Executive Tags
                </h6>
              </div>
              <div className="card-body" style={{ minHeight: "250px" }}>
                <div className="searchbox" style={{ marginBottom: "15px" }}>
                  <Input
                    placeholder="Search Tag"
                    prefix={<SearchOutlined />}
                    onChange={filterExecutiveTag}
                  />
                </div>
                <div className="card-body">
                  <Space size={[0, executiveTagData?.length]} wrap>
                    {executiveTagData?.map((item, index) => {
                      let cnt = index;
                      if (index > colorArray.length) {
                        cnt = 0;
                        cnt++;
                      }
                      return (
                        <Tag
                          key={`executive-tag-${index}`}
                          color={colorArray[cnt]}
                        >
                          <a onClick={() => doSearchByTag(item, 2)}>{item}</a>
                        </Tag>
                      );
                    })}
                  </Space>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};
export default TagsReport;
